/* Materia Themes — Cart-drawer safety net.
   ─────────────────────────────────────────────────────────────────────
   Document-level capture-phase listener for trash-icon clicks in the
   cart drawer. The original <mini-cart-remove-button> custom element
   handler still exists as a feature target — but a single broken
   render or a JS error there has historically left the drawer stuck,
   requiring a full page reload to recover. This file is the
   bulletproof backup that always runs and always wins.

   Why capture phase + stopImmediatePropagation?
   - Capture-phase listeners fire BEFORE the inner <a href> default
     action and BEFORE any bubble-phase listeners on the custom
     element. We call preventDefault to kill the link navigation, then
     stopImmediatePropagation when we own the delete so the custom-
     element handler can't double-fire and double-decrement the cart.

   Why we still defer to the custom element for wishlist-mode clicks:
   - When `show_message_when_remove` is enabled in settings, the trash
     button gets `.action-add-wishlist` and the first click shows a
     "remove and save to wishlist?" confirmation panel instead of
     deleting. If the product isn't yet in the wishlist we let the
     custom-element handler take over by NOT stopping propagation.
*/
"use-strict";

(function () {
  function findCartContainer() {
    return (
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer")
    );
  }
  function isInWishlist(productHandle) {
    try {
      const raw = localStorage.getItem("materia__wishlist-items");
      if (!raw) return false;
      const list = JSON.parse(raw);
      return Array.isArray(list) && list.indexOf(productHandle) !== -1;
    } catch (_) {
      try { localStorage.removeItem("materia__wishlist-items"); } catch (_) {}
      return false;
    }
  }
  function fallbackDelete(lineKey) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .catch(() => null)
      .then(() => {
        try { window.location.reload(); } catch (_) {}
      });
  }
  function selfHeal() {
    document.querySelectorAll("cart-items.cart-refreshing")
      .forEach((el) => el.classList.remove("cart-refreshing"));
    document.querySelectorAll("mini-cart-remove-button.loading")
      .forEach((el) => el.classList.remove("loading"));
  }

  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const trash = target.closest("mini-cart-remove-button");
      if (!trash) return;
      event.preventDefault();
      const wishlistMode = trash.classList.contains("action-add-wishlist");
      if (wishlistMode && !isInWishlist(trash.dataset.productHandle)) {
        return;
      }
      event.stopImmediatePropagation();
      const lineKey = trash.dataset.index;
      if (!lineKey) {
        console.warn("[cart] trash button missing data-index", trash);
        return;
      }
      selfHeal();
      const cartEl = findCartContainer();
      if (cartEl && typeof cartEl.updateQuantity === "function") {
        try {
          cartEl.updateQuantity(lineKey, 0);
          return;
        } catch (err) {
          console.warn("[cart] updateQuantity threw — falling back to direct delete", err);
        }
      }
      fallbackDelete(lineKey);
    },
    true
  );
})();

/* Mundo LED — fotografías del directorio. Solo actúa en la página de contacto. */
(function () {
  const PHOTO_MAP = {
    "julian castillo": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/julian-castillo-directorio.jpg?v=1789593807", "Julian Castillo - Asesor Comercial"],
    "maria canizales": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/maria-canizales-directorio.jpg?v=1789593722", "Maria Canizales - Jefe de Tienda"],
    "jhon jairo angulo": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/jhon-jairo-directorio.jpg?v=1789593801", "Jhon Jairo - Auxiliar de Bodega"],
    "julian quintero": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/julian-quintero-directorio.jpg?v=1789593790", "Julian Quintero - Supervisor de Bodega"],
    "j jairo bravo": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/j-jairo-bravo-directorio.jpg?v=1789593795", "J. Jairo Bravo - Auxiliar de Bodega"],
    "samuel jimenez": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/samuel-jimenez-directorio.jpg?v=1789593715", "Samuel Jimenez - Auxiliar de Bodega"],
    "kathy hernandez": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/kathy-hernandez-directorio.jpg?v=1789593771", "Kathy Hernandez - Auxiliar Contable"],
    "yurani ramirez": ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/yurani-ramirez-directorio.jpg?v=1789593777", "Yurani Ramirez - Facturación"]
  };
  const SEBASTIAN = ["https://cdn.shopify.com/s/files/1/0837/1650/5825/files/sebastian-herrera-directorio.jpg?v=1789593784", "Sebastian Herrera - Auxiliar de Bodega"];

  function normalise(value) {
    return (value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function applyDirectoryPhotos() {
    if (!document.querySelector(".ml-name")) return;

    document.querySelectorAll(".ml-name").forEach(function (nameEl) {
      const key = normalise(nameEl.textContent);
      const photo = PHOTO_MAP[key];
      if (!photo) return;
      const card = nameEl.closest(".ml-card");
      if (!card) return;
      const img = card.querySelector("img.ml-logo");
      if (!img) return;
      img.src = photo[0];
      img.alt = photo[1];
      img.loading = "lazy";
      img.decoding = "async";
      img.dataset.mundoledDirectoryPhoto = "1";
    });

    if (document.querySelector('[data-mundoled-sebastian="1"]')) return;
    const cityBlocks = Array.from(document.querySelectorAll(".ml-city"));
    const bodegaBlock = cityBlocks.find(function (block) {
      return normalise(block.textContent).includes("bodega");
    });
    if (!bodegaBlock) return;
    const grid = bodegaBlock.querySelector(".ml-grid");
    if (!grid) return;

    const card = document.createElement("div");
    card.className = "ml-card ml-pending";
    card.setAttribute("data-mundoled-sebastian", "1");
    card.innerHTML = '<div><span class="ml-name">Sebastian Herrera</span><span class="ml-position">Auxiliar de bodega</span><span class="ml-pending-note">Número pendiente</span></div><img class="ml-logo" src="' + SEBASTIAN[0] + '" alt="' + SEBASTIAN[1] + '" loading="lazy" decoding="async">';
    grid.appendChild(card);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyDirectoryPhotos);
  } else {
    applyDirectoryPhotos();
  }

  document.addEventListener("shopify:section:load", applyDirectoryPhotos);
})();
